<template>
  <v-dialog v-model="model" :width="props.width" class="app-dialog">
    <v-card class="rounded-lg">
      <slot name="title">
        <v-row class="align-center">
          <v-col>
            <v-card-title class="app-dialog__title">{{ props.title }}</v-card-title>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn
              icon="mdi-close"
              variant="plain"
              class="app-dialog__close"
              @click="$emit('update:modelValue', false)"
            ></v-btn>
          </v-col>
        </v-row>
      </slot>
      <v-divider></v-divider>
      <slot name="content">
        <v-card-text class="app-dialog__text">{{ props.text }}</v-card-text>
      </slot>
      <slot name="actions">
        <v-row class="ma-0 justify-end">
          <v-col cols="4" class="pr-0">
            <v-btn
              color="grey-darken-3"
              class="app-dialog__cancel"
              variant="text"
              block
              @click="$emit('cancel')"
            >
              {{ props.cancelText }}
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              color="primary"
              class="app-dialog__confirm"
              block
              :loading="confirming"
              @click="$emit('confirm')"
            >
              {{ props.confirmText }}
            </v-btn>
          </v-col>
        </v-row>
      </slot>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    modelValue?: boolean
    width?: number
    title?: string
    text?: string
    confirming?: boolean
    cancelText?: string
    confirmText?: string
  }>(),
  {
    width: 500,
    cancelText: 'No',
    confirmText: 'Yes',
  },
)

const model = computed({
  get: () => {
    return props.modelValue
  },
  set: (value) => {
    emit('update:modelValue', value)
  },
})

const emit = defineEmits(['update:modelValue', 'cancel', 'confirm'])
</script>
